import { render, staticRenderFns } from "./auction-sales-list.vue?vue&type=template&id=a6399470&scoped=true"
import script from "./auction-sales-list.vue?vue&type=script&lang=js"
export * from "./auction-sales-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6399470",
  null
  
)

export default component.exports